module.exports = __webpack_public_path__ + "img/bug.909c0cca.png";